import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { Product, ProductDetail } from 'src/@omnial/_models/catalog/product.model';
import { Review } from 'src/@omnial/_models/customer/review.model';

@Component({
    selector: 'app-rating',
    templateUrl: './../../../app/shared/rating/rating.component.html',
    styleUrls: ['./../../../app/shared/rating/rating.component.scss'],
    standalone: false
})
export class RatingComponent implements OnInit {
  @Input() direction: string;
  @Input() large: boolean;
  @Input() product: any; // Could be Detail or Simple
  @Input() review: Review;
  @Input() showNumber: boolean;
  @Input() showViewLink: boolean;
  public ratingsCount: number;
  public ratingsValue: number;
  avg: number;
  stars: Array<string>;
  initialised: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  public init(product?: ProductDetail): void {
    if (product) {
      this.product = product;
      this.ratingsCount = product.ratingsCount;
      this.ratingsValue = product.ratingsValue;
    } else if (this.review){
      this.ratingsCount = 1;
      this.ratingsValue = this.review.rating;
    } else {
      this.ratingsCount = this.product?.ratingsCount;
      this.ratingsValue = this.product?.ratingsValue;
    }
    if (this.ratingsCount && this.ratingsValue) {
      this.calculateAvgValue();
    } else {
      this.ratingsCount = 0;
      this.stars = ['star', 'star', 'star', 'star', 'star'];
    }
  }

  rate(value): void {
    value = (value + 1) * 20;
    this.ratingsCount++;
    this.ratingsValue = this.ratingsValue + value;
    this.calculateAvgValue();
  }

  calculateAvgValue(): void {
    this.avg = (this.ratingsValue / this.ratingsCount) * 20;
    switch (true) {
      case this.avg > 0 && this.avg < 20: {
        this.stars = ['star_half', 'star_border', 'star_border', 'star_border', 'star_border'];
        break;
      }
      case this.avg === 20: {
        this.stars = ['star', 'star_border', 'star_border', 'star_border', 'star_border'];
        break;
      }
      case this.avg > 20 && this.avg < 40: {
        this.stars = ['star', 'star_half', 'star_border', 'star_border', 'star_border'];
        break;
      }
      case this.avg === 40: {
        this.stars = ['star', 'star', 'star_border', 'star_border', 'star_border'];
        break;
      }
      case this.avg > 40 && this.avg < 60: {
        this.stars = ['star', 'star', 'star_half', 'star_border', 'star_border'];
        break;
      }
      case this.avg === 60: {
        this.stars = ['star', 'star', 'star', 'star_border', 'star_border'];
        break;
      }
      case this.avg > 60 && this.avg < 80: {
        this.stars = ['star', 'star', 'star', 'star_half', 'star_border'];
        break;
      }
      case this.avg === 80: {
        this.stars = ['star', 'star', 'star', 'star', 'star_border'];
        break;
      }
      case this.avg > 80 && this.avg < 100: {
        this.stars = ['star', 'star', 'star', 'star', 'star_half'];
        break;
      }
      case this.avg >= 100: {
        this.stars = ['star', 'star', 'star', 'star', 'star'];
        break;
      }
      default: {
        this.stars = ['star', 'star', 'star', 'star', 'star'];
        break;
      }
    }
  }

}
